var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaseBooking01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.66,5.81V12a.7.7,0,0,1-.42.69L9.17,15.37l-.19.1V8.87a.28.28,0,0,1,.18-.29l5.29-2.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.86,5.8l.83.42.88.44a.25.25,0,0,1,.19.26V9.53c0,.31.11.41.4.32a.5.5,0,0,1,.6.17l.28.3c.09.1.2.18.32.1a.38.38,0,0,0,.14-.29V7.64l.16.07,1.78.91a.22.22,0,0,1,.12.16v6.68l-.18-.09-5.2-2.71a.57.57,0,0,1-.33-.53V5.93A.53.53,0,0,1,2.86,5.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.4,5.43l-1.59.8L9.05,8.14a.57.57,0,0,1-.59,0c-.57-.3-1.15-.58-1.74-.88L7.16,7l5.09-2.58a.27.27,0,0,1,.32,0l1.67.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.69,3.47,8.49,4.58c-1.12.57-2.25,1.13-3.37,1.71a.31.31,0,0,1-.32,0L3.1,5.43l.16-.09L8.45,2.6a.59.59,0,0,1,.6,0l1.52.8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.76,18A9,9,0,0,1,.27,12,.38.38,0,0,1,1,11.71,8.24,8.24,0,1,0,1.54,5a.37.37,0,1,1-.65-.36A9,9,0,1,1,8.76,18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.44,5.81V2.63a.38.38,0,1,1,.75,0V4.82l2-.58a.38.38,0,0,1,.47.26A.37.37,0,0,1,3.43,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseBooking01);
export default __webpack_public_path__ + "static/media/case_booking-01.39664bb6.svg";
export { ForwardRef as ReactComponent };